import React, { useState } from "react";
import classnames from "classnames";
import { useTranslation } from "react-i18next";
import "./styles.less";
import { Link } from "../../components/LinkIcon";
import { tryNow } from "../../utils";

export const SolutionIndustryBanner = (props) => {
  const { title, subtitle, imgUrl, downSolution, tagFrom } = props;

  const [visible, setVisible] = useState(false);

  const { t } = useTranslation();

  const openROI = () => {
    window.open("https://host.huiju.cool/p/b1e3e");
  };
  const openDownSolution = () => {
    window.open(downSolution);
  };

  return (
    <div>
      <section
        className="solution-industry-banner"
        style={{ background: `url(${imgUrl})` }}
      >
        <div className="solution-industry-banner-content">
          <div className="solution-industry-banner-text">
            <h3 className="title">{title}</h3>
            <div className="subtitle">{subtitle}</div>
            <div className="solution-button-warp">
              <div
                className="solution-button"
                onClick={() => {
                  // setVisible(true);
                  window.open(
                    tagFrom
                      ? `https://www.authing.cn/authingform?fromTag=${tagFrom}`
                      : "https://www.authing.cn/authingform"
                  );
                }}
              >
                {t("solution.detail.button-consult")}
              </div>
              <div className="solution-button-link">
                <Link
                  style={{ color: "#fff" }}
                  onClick={downSolution ? openDownSolution : openROI}
                >
                  {downSolution
                    ? t("common.down-solution")
                    : t("common.button.try-now-roi")}
                  {}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
